import type { OrganizationDto } from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getById } from "../../api/OrgsApi"
import { ErrorBanner, LoadingErrorState, RoundedCard } from "../../components"
import OrgMask from "../../components/admin/OrgMask"
import { isProd } from "../../config"

export function AdminOrgCreateEditForm() {
  const [isNewOrg, setIsNewOrg] = useState<boolean>(true)
  const [org, setOrg] = useState<OrganizationDto | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | undefined>(undefined)
  const params = useParams<{
    orgId: string | undefined
  }>()

  useEffect(() => {
    const loadOrg = async (orgId: string) => {
      !isProd && console.debug("ceo: > loadOrg")
      setLoading(true)
      setOrg(null)
      setError(undefined)
      try {
        const _isNewOrg = "new" === orgId
        const _orgPromise = !_isNewOrg
          ? getById(orgId)
          : Promise.resolve({
              id: "",
              name: "",
              created_at: "",
              created_by: "",
              updated_at: "",
              updated_by: "",
              address: "",
              Ausladegruppen: [],
              FeedComponents: [],
              Recipes: [],
              Machines: [],
            })
        const _org = await _orgPromise
        if (!_org) {
          throw new Error("Could not load org")
        }
        setOrg(_org)
        setIsNewOrg(_isNewOrg)
      } catch (err) {
        console.log(
          "ceo.loadOrg: Caught an error:",
          JSON.stringify(err, null, 2)
        )
        setError(getErrorMessage(err))
      } finally {
        setLoading(false)
      }
    }
    if (params.orgId) {
      if (!isProd) {
        if ("new" === params.orgId) {
          console.debug("Heck, this is a new org.")
        } else {
          console.debug("orgId:", params.orgId)
        }
      }
      loadOrg(params.orgId)
    } else {
      console.error("No orgId parameter")
    }
  }, [params.orgId])

  if (loading || error) {
    return (
      <LoadingErrorState
        isLoading={loading}
        loadingMessage={I18n.get("Lade Betriebsdaten, bitte warten...")}
        isError={!!error}
        errorMessage={`${I18n.get("Fehler")}: ${I18n.get(error!)}`}
      />
    )
  }

  if (!org) {
    return <ErrorBanner error={I18n.get("Betrieb erstellen fehlgeschlagen!")} />
  } else {
    const loadedOrg = org!
    return (
      <main className="p-8 pt-2">
        <div className="page-heading mb-4">
          {I18n.get(isNewOrg ? "Betrieb anlegen" : "Betrieb bearbeiten")}
        </div>

        <RoundedCard>
          <OrgMask org={loadedOrg} isNewOrg={isNewOrg} />
        </RoundedCard>
      </main>
    )
  }
}
